import script from "./CustomerDictionaryTemplateSelectModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDictionaryTemplateSelectModal.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDictionaryTemplateSelectModal.vue?vue&type=style&index=0&id=209df1d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209df1d8"]])

export default __exports__